import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { JobStatus } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class JobStatusService extends TmsWebBaseEditService<JobStatus, JobStatus> {
  constructor() {
    super('JobStatus', $localize`Job Status`);
  }
}
